import axiosInstance from './axiosInstance';
import { IAuthTokenResponse, IUserProfile } from '../interfaces';
import TokenService from './TokenService.ts';

class AuthService {
  private static instance: AuthService;
  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public async login(
    username: string,
    password: string
  ): Promise<IAuthTokenResponse> {
    try {
      const response = await axiosInstance.post<IAuthTokenResponse>(
        '/auth/login',
        {
          username,
          password,
        }
      );

      const data = response.data;

      // Save the tokens in the local storage
      TokenService.setTokens(data.access_token, data.refresh_token, data.token);

      return data;
    } catch (error: any) {      
      // Use error message from service or default
      const errorMessage = error.response?.data?.detail || 'Login failed';
      throw new Error(errorMessage);
    }
  }

  public async me(): Promise<IUserProfile> {
    try {
      const response = await axiosInstance.get<IUserProfile>('/auth/me');
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch user profile');
    }
  }

  public async forgotPassword(username: string): Promise<{ status: boolean; account: any; error: any }> {
    try {
      const response = await axiosInstance.post('/auth/forgot_password', {
        username,
      });
      return response.data;
    } catch (error) {
      console.error('Forgot password request failed:', error);
      throw new Error('Forgot password request failed');
    }
  }

  public async checkPasswordResetToken(token: string): Promise<void> {
    try {
      await axiosInstance.post('/auth/check_password_reset_token', {
        token,
      });
    } catch (error) {
      console.error('Check password reset token request failed:', error);
      throw new Error('Check password reset token request failed');
    }
  }

  public async resetPassword(token: string, password: string, passwordConfirm: string): Promise<void> {
    try {
      await axiosInstance.post('/auth/reset_password', {
        token,
        password,
        password_confirm: passwordConfirm,
      });
    } catch (error) {
      console.error('Reset password request failed:', error);
      throw new Error('Reset password request failed');
    }
  }
}

export default AuthService.getInstance();
